import axios from "axios";
import { BaseService } from "./base.service";
import { BaseResponse, BaseResponseExternal } from "./dtos/base.dto";
import {
  BillsResponse,
  DaftarZiswafResponse,
  PaymentSavingRequest,
  PocketResponse,
  VirtualAccountReportResponse,
  VirtualAccountRequest,
  VirtualAccountRequestZiswaf,
} from "./dtos/finance.dto";

interface FinanceServiceInterface {
  queries: {
    GET_FINANCE_BILLS_PAID_OF: string;
    GET_FINANCE_ZIS: string;
    GET_FINANCE_POCKET: string;
  };
  billsPaidOf(payload: { nis: string }): Promise<BillsResponse>;
  virtualAccountRequest(payload: VirtualAccountRequest): Promise<BaseResponse>;
  virtualAccountReport(payload: {
    nis: string;
    limit: string;
  }): Promise<VirtualAccountReportResponse>;
  virtualAccountCheckStatus(payload: { trxID: string }): Promise<BaseResponse>;
  virtualAccountCancel(id: string): Promise<BaseResponse>;
  ziswafList(): Promise<DaftarZiswafResponse>;
  virtualAccountRequestZiswaf(
    payload: VirtualAccountRequestZiswaf
  ): Promise<BaseResponse>;
  paymentSavingRequest(payload: PaymentSavingRequest): Promise<BaseResponse>;
  pocket(): Promise<PocketResponse>;
}

export const FinanceService: FinanceServiceInterface = {
  queries: {
    GET_FINANCE_BILLS_PAID_OF: "GET_FINANCE_BILLS_PAID_OF",
    GET_FINANCE_ZIS: "GET_FINANCE_ZIS",
    GET_FINANCE_POCKET: "GET_FINANCE_POCKET",
  },
  billsPaidOf: async (payload: { nis: string }) => {
    try {
      const request = await axios.get<BillsResponse>(
        `https://dsdlingoorangtuaapi.sipond.id/api/tagihan/data`,
        // payload,
        {
          params: payload,
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
    // try {
    //   const request = await BaseService.request().get<BillsResponse>(
    //     "/finance/bills-paid-of"
    //   );

    //   return BaseService.response(request);
    // } catch (error: any) {
    //   return BaseService.response(error, true);
    // }
  },

  ziswafList: async () => {
    try {
      const request = await axios.get(
        `https://dsdlingoorangtuaapi.sipond.id/api/tagihan/daftar-ziswaf`,
        {
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );

      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  virtualAccountRequest: async (payload: VirtualAccountRequest) => {
    try {
      const request = await axios.post<
        BaseResponseExternal<{
          trxAmount: number;
          nis: string;
          customerName: string;
          virtualAccount: string;
          datetimeExpired: Date;
          trxID: string;
          jenis: string;
          requestPayment: string;
        }>
      >(
        "https://dsdlingoorangtuaapi.sipond.id/api/tagihan/submit-va",
        payload,
        {
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },

  virtualAccountReport: async (payload: { nis: string; limit: string }) => {
    try {
      const request = await axios.get<VirtualAccountReportResponse>(
        `https://dsdlingoorangtuaapi.sipond.id/api/tagihan/data-va`,
        {
          params: payload,
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
    // try {
    //   const request = await BaseService.request().get<BillsResponse>(
    //     "/finance/bills-paid-of"
    //   );

    //   return BaseService.response(request);
    // } catch (error: any) {
    //   return BaseService.response(error, true);
    // }
  },

  virtualAccountCheckStatus: async (payload: { trxID: string }) => {
    try {
      const request = await axios.get<BaseResponseExternal>(
        `https://dsdlingoorangtuaapi.sipond.id/api/tagihan/check-status`,
        {
          params: payload,
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },

  virtualAccountCancel: async (id: string) => {
    try {
      const request = await BaseService.request().get<BillsResponse>(
        `/finance/virtual-accounts-cancel/${id}`
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  virtualAccountRequestZiswaf: async (payload: VirtualAccountRequestZiswaf) => {
    try {
      const request = await axios.post<BaseResponseExternal>(
        "https://dsdlingoorangtuaapi.sipond.id/api/tagihan/submit_va_ziswaf",
        payload,
        {
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },

  paymentSavingRequest: async (payload: PaymentSavingRequest) => {
    try {
      const request = await axios.post<
        BaseResponseExternal<{
          trxAmount: number;
          nis: string;
          customerName: string;
          virtualAccount: string;
          datetimeExpired: Date;
          trxID: string;
          jenis: string;
          requestPayment: string;
        }>
      >(
        "https://dsdlingoorangtuaapi.sipond.id/api/tagihan/submit_bayar_tagihan_lama",
        payload,
        {
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },

  pocket: async () => {
    try {
      const request = await BaseService.request().get<BillsResponse>(
        "/finance/pocket"
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
};
